import { emailPattern, SellerBuyerInfo } from '@app/types';
import React, { useEffect, useState } from 'react';
import {
  InputContainer,
  InfoBox,
  InputCard,
  ErrorMessage,
  PrimaryInfoBox,
  ButtonBox,
  ButtonText,
  PrimarySeperator,
  CheckBoxContainer,
  Right,
  EntityContainer,
  MlsLink,
} from '@app/modules/transaction-form/transactions-form-components';
import { Checkbox, Input, RadioButton } from '@app/components';
import { removeArrEle } from '@app/utils';

type Props = {
  register: any;
  isSubmitted: boolean;
  errors: any;
  users: SellerBuyerInfo[];
  transactionId: string;
  setUsers: (users: SellerBuyerInfo[]) => void;
  userType: string;
};
export default function SellerBuyerDetails({
  users,
  isSubmitted,
  errors,
  transactionId,
  register,
  setUsers,
  userType,
}: Props) {
  const [usersList, setUsersList] = useState<SellerBuyerInfo[]>([]);

  useEffect(() => {
    if (users && users.length) {
      setUsersList(users);
    }
  }, [users]);
  /**
   *
   * @param index index of the removing seller
   */
  const handleUserRemove = (index: number) => {
    const list = [...usersList];
    const updatedList = removeArrEle(list, index);
    setUsers(updatedList);
    setUsersList(updatedList);
  };

  /**
   *
   * @param event click event
   * @param type type of field changed
   * @param index index of the field changed
   */
  const onChange = (event: any, type?: string, index?: number) => {
    const { name: fieldName, value: fieldValue } =
      (event && event.target) || '';
    if (!/^\s+$/.test(fieldValue) && index !== undefined) {
      const list = [...users];
      if (fieldName === 'name') {
        Object.assign(list[index], {
          name: fieldValue,
        });
        setUsersList(list);
        setUsers(list);
      } else if (fieldName === 'address') {
        Object.assign(list[index], {
          address: fieldValue,
        });
        setUsers(list);
        setUsersList(list);
      } else if (fieldName === 'email') {
        Object.assign(list[index], { email: fieldValue });
        setUsers(list);
        setUsersList(list);
      } else if (type === 'number') {
        Object.assign(list[index], { phone: event });
        setUsers(list);
        setUsersList(list);
      } else if (fieldName === 'contact_name') {
        list[index].subDetails = {
          ...list[index].subDetails,
          contactNameForBusiness: fieldValue,
        };
        setUsers(list);
        setUsersList(list);
      }
    }
  };

  /**
   *
   * @param e on change event
   * @param type type of the changing element
   * @param index index of the changing element
   */
  const onRadioButtonClick = (e: any, type: string, index: number) => {
    let users = [...usersList];
    let checked: boolean = e.target.checked;
    if (type === 'entity') {
      users[index].subDetails = {
        ...users[index].subDetails,
        isEntity: checked,
        isIndividual: false,
      };
    } else if (type === 'individual') {
      users[index].subDetails = {
        ...users[index].subDetails,
        isIndividual: checked,
        contactNameForBusiness: '',
        isEntity: false,
      };
    }
    setUsers(users);
    setUsersList(users);
  };

  /**
   *
   */
  const handleUserAdd = () => {
    setUsers([
      ...users,
      {
        name: '',
        address: '',
        email: '',
        phone: '',
        new: true,
        showEntityCheckbox: true,
        showRadioButtons: false,
        subDetails: {
          isEntity: false,
          isIndividual: false,
        },
      },
    ]);
  };

  /**
   *
   * @param e on change event
   * @param index index of the changing element
   */
  const onCheck = (e: any, index: number) => {
    let users = [...usersList];
    users[index].showRadioButtons = e.target.checked;
    if (!e.target.checked) {
      users[index].subDetails = {
        ...users[index].subDetails,
        isEntity: e.target.checked,
        isIndividual: e.target.checked,
        contactNameForBusiness: '',
      };
    }
    setUsers(users);
    setUsersList(users);
  };

  return (
    <>
      {users && users.length
        ? users.map((user: SellerBuyerInfo, i: number) => {
            return (
              <InputContainer key={i}>
                <EntityContainer>
                  {user.showEntityCheckbox ? (
                    <InputCard>
                      <Checkbox
                        noBottom
                        name={`proUserEntityBox-${i}`}
                        label="Are you an Individual or Entity/Trust?"
                        checked={user.showRadioButtons}
                        onChange={(e: any) => onCheck(e, i)}
                      />
                    </InputCard>
                  ) : null}
                </EntityContainer>
                <EntityContainer>
                  <InputCard>
                    {user.showEntityCheckbox && user.showRadioButtons ? (
                      <>
                        <CheckBoxContainer>
                          <RadioButton
                            type="radio"
                            label="Individual"
                            value={`individual${i}`}
                            onChange={(e: any) =>
                              onRadioButtonClick(e, 'individual', i)
                            }
                            checked={
                              user.subDetails
                                ? user.subDetails.isIndividual
                                : false
                            }
                          />
                          <Right>
                            <RadioButton
                              type="radio"
                              label="Entity/Trust"
                              value={`entity${i}`}
                              onChange={(e: any) =>
                                onRadioButtonClick(e, 'entity', i)
                              }
                              checked={
                                user.subDetails
                                  ? user.subDetails.isEntity
                                  : false
                              }
                            />
                          </Right>
                        </CheckBoxContainer>
                        {isSubmitted &&
                          user.showRadioButtons &&
                          user.subDetails &&
                          !user.subDetails.isEntity &&
                          !user.subDetails.isIndividual && (
                            <ErrorMessage style={{ marginTop: '0px' }}>
                              Please Select Entity Or Individual
                            </ErrorMessage>
                          )}
                      </>
                    ) : null}
                  </InputCard>
                </EntityContainer>
                <InfoBox>
                  <InputCard>
                    <Input
                      label={
                        user.subDetails && user.subDetails.isEntity
                          ? 'Business Name'
                          : 'Name'
                      }
                      star="*"
                      placeholder="Enter Name"
                      name="name"
                      value={user.name ? user.name : ''}
                      onChange={e => onChange(e, '', i)}
                      register={register({
                        required: true,
                        validate: (value: any) =>
                          !/^\s+$/.test(value) || 'Please Enter Name',
                      })}
                    />
                    {isSubmitted && !user.name && (
                      <ErrorMessage>Please Enter Name</ErrorMessage>
                    )}
                  </InputCard>
                  {user.subDetails && user.subDetails.isEntity ? (
                    <InputCard>
                      <Input
                        name="contact_name"
                        placeholder="Enter Contact Name"
                        label="Contact Name for the Business"
                        value={user.subDetails.contactNameForBusiness}
                        onChange={(e: any) => onChange(e, 'contact_name', i)}
                      />
                    </InputCard>
                  ) : null}
                </InfoBox>
                <PrimaryInfoBox>
                  <InputCard>
                    <Input
                      type="email"
                      label="Email"
                      showDefaultValue={true}
                      placeholder="Enter Email"
                      name="email"
                      value={user.email ? user.email : ''}
                      onChange={e => onChange(e, '', i)}
                      register={register({
                        pattern: emailPattern,
                      })}
                    />
                  </InputCard>
                  <InputCard>
                    <Input
                      type="phone_number"
                      label="Phone Number"
                      placeholder="Enter Phone Number"
                      name="number"
                      value={
                        (user.phone && user.phone.startsWith('+1')
                          ? user.phone.substring(2)
                          : user.phone) || ''
                      }
                      onChange={e => onChange(e, 'number', i)}
                      register={register({})}
                    />
                  </InputCard>
                </PrimaryInfoBox>
                <MlsLink>
                  <Input
                    label="Address"
                    placeholder="Enter Address"
                    name="address"
                    value={user.address ? user.address : ''}
                    onChange={e => onChange(e, '', i)}
                    register={register({})}
                  />
                </MlsLink>
                <ButtonBox>
                  {users.length !== 1 && (
                    <ButtonText onClick={() => handleUserRemove(i)}>
                      {userType === 'seller' ? 'Remove Seller' : 'Remove Buyer'}
                    </ButtonText>
                  )}
                  {users.length - 1 === i && (
                    <ButtonText onClick={handleUserAdd}>
                      {userType === 'seller' ? 'Add Seller' : 'Add Buyer'}
                    </ButtonText>
                  )}
                </ButtonBox>
                {users.length - 1 !== i && <PrimarySeperator />}
              </InputContainer>
            );
          })
        : null}
    </>
  );
}
